<template>
  <div class="device-selector">
    <div class="device-selector__required-button">
      <b-button block variant="outline-primary" @click="openModal">
        Select Device
      </b-button>
      <span v-if="required" class="text-danger">*</span>
    </div>
    <div v-if="loading">
      <b-spinner />
    </div>
    <div v-if="selectedDevice" class="device-selector__selected-device">
      <div>
        <b-img
          v-if="selectedDevice.thumbnail"
          height="50px"
          width="50px"
          :src="
            `https://res.cloudinary.com/gokaizen/image/upload/w_100,h_100,c_fit/kzcdn/${selectedDevice.thumbnail}`
          "
        />
        {{ selectedDevice.manufacturer_name }}
        {{ selectedDevice.name }}
        [{{ selectedDevice.type_name }}]
      </div>
      <b-icon
        icon="x"
        class="device-selector__delete-icon"
        @click="resetDevice"
      />
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';

import EventBus from '@/services/bus';

export default {
  components: {},
  props: {
    value: {
      type: [Number],
      required: false,
      default: null,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      selectedDeviceId: this.value,
      selectedDeviceType: null,
      busId: Math.random()
        .toString(36)
        .substring(7),
    };
  },
  computed: {
    ...mapState('devices', {
      devicesLoading: 'loading',
    }),
    ...mapGetters('devices', {
      deviceById: 'getDevice',
    }),
    selectedDevice() {
      return this.deviceById(this.value);
    },
    loading() {
      return this.devicesLoading;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.selectedDeviceId = value;
      },
    },
  },
  methods: {
    openModal() {
      EventBus.$once(
        `device-selector-modal-select-${this.busId}`,
        (deviceId) => {
          this.selectedDeviceId = deviceId;
          this.$emit('input', deviceId);
        },
      );
      EventBus.$emit('open-device-selector-modal', [
        this.busId,
        this.selectedDeviceId,
      ]);
    },
    resetDevice() {
      this.selectedDeviceId = null;
      this.$emit('input', null);
    },
  },
};
</script>
<style scoped>
.device-selector {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
}
.device-selector__required-button {
  display: flex;
  gap: 10px;
}
.device-selector__selected-device {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 8px;
  padding: 8px;
  /* background-color: #eee; */
  border: solid 1px #ccc;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  border-top: none;
}
.device-selector__delete-icon {
  cursor: pointer;
  font-size: 2em;
}
.device-selector__delete-icon:hover {
  color: red;
}
</style>
